
















































































import Vue from "vue";
import api from "../services/api";
import Tabs from "@/components/Tabs.vue";
import CheckBox from "@/components/CheckBox.vue";
import configuration from "@/models/Configuration";
import { StatementReportType } from "../models/GeneralLedgerStatement";

// Dim-szám (type-1) → római felirat a Dim 4-12 fülek "Dim" oszlopához (K2D st_4..st_12 minta).
const DIM_ROMAN: { [type: number]: string } = {
  5: "IV", 6: "V", 7: "VI", 8: "VII", 9: "VIII", 10: "IX", 11: "X", 12: "XI", 13: "XII",
};

interface TabDef {
  key: string;
  label: string;
  columns: any[];
  // year-függő (a fül adatát a kiválasztott könyvelési évre tölti)
  yearDependent?: boolean;
  // kijelölhető fül: pipa-oszlop, a kijelölt elemek szűrik a riportot (K2D választó-lista)
  selectable?: boolean;
  // dim-fül: a szűrő-modell VAGY/ÉS mezőjének neve (K2D rb_dim_or / cbx_dim_or*)
  dimOrKey?: string;
}
interface TabView extends TabDef {
  enabled: boolean;
  headerLabel: string;
}

interface PageState {
  skip: number;
  take: number;
}
interface Data {
  tabDefs: TabDef[];
  rows: { [key: string]: any[] };
  search: { [key: string]: string | null };
  onlySelected: { [key: string]: boolean };
  // Dim-fülönként a VAGY/ÉS kapcsoló állása (true = VAGY); a kulcs a fül kulcsa.
  dimOr: { [key: string]: boolean };
  paging: { [key: string]: PageState };
  pageable: any;
  staticLoaded: boolean;
  // K2D gs_is_dim_4_9 rendszerparaméter (pssyssysfile1.is_dim_4_9, konfig: isDim49):
  // '+' esetén a Dim 4-12 fülek aktívak (K2D srw 2322-2335 – mód-független).
  dim4to12Enabled: boolean;
}
interface Methods {
  loadStatic(): void;
  loadYear(): void;
  safeLoad(key: string, fn: () => Promise<any[]>): Promise<void>;
  isTabEnabled(key: string): boolean;
  gridColumns(t: TabView): any[];
  filteredRows(t: TabView): any[];
  pagedRows(t: TabView): any[];
  onPageChange(key: string, e: any): void;
  onSearch(key: string, value: string | null): void;
  setOnlySelected(key: string, value: boolean): void;
  setDimOr(key: string, value: boolean): void;
  selCount(key: string): number;
  onSelect(key: string, item: any, value: boolean): void;
  clearTab(key: string): void;
  clearAll(): void;
  emitSelection(): void;
}
interface Computed {
  isCarton: boolean;
  tabs: TabView[];
}
interface Props {
  reportType: number;
  yearId: number;
  calendarYear: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "StatementSelectorTabs",
  components: { Tabs, CheckBox },

  props: {
    // StatementReportType – a fülek módonkénti engedélyezéséhez (K2D w_popup_report_brief).
    reportType: { type: Number, default: StatementReportType.Brief },
    // mmbokyear.szam – a Pontozás (recon) fülhöz (recon.year FK).
    yearId: { type: Number, default: 0 },
    // Naptári év – a Fksz (invoice-mirror) és Dim (dimension) végpontokhoz (y.Year == évszám).
    calendarYear: { type: Number, default: 0 },
  },

  data(): Data {
    return {
      // K2D: gs_is_dim_4_9 = pssyssysfile1.is_dim_4_9 (a configuration az app-inditáskor tölti).
      dim4to12Enabled: configuration.isDim49,
      staticLoaded: false,
      rows: {
        accno: [],
        dim13: [],
        dim46: [],
        dim79: [],
        dim1012: [],
        partner: [],
        car: [],
        project: [],
        po: [],
        recon: [],
      },
      search: {
        accno: "",
        dim13: "",
        dim46: "",
        dim79: "",
        dim1012: "",
        partner: "",
        car: "",
        project: "",
        po: "",
      },
      onlySelected: {
        accno: false,
        dim13: false,
        dim46: false,
        dim79: false,
        dim1012: false,
        partner: false,
        car: false,
        project: false,
        po: false,
      },
      // K2D: mind a négy dim-fül VAGY/ÉS vezérlője alapból VAGY (rb_dim_or / cbx_dim_or* checked).
      dimOr: {
        dim13: true,
        dim46: true,
        dim79: true,
        dim1012: true,
      },
      // Kliens-oldali lapozás fülönként (a teljes lista fent van, csak a render lapozott).
      // MINDEN fül-kulcs kell (a csak kartonon élő szla és a kapcsolható dim4-12 is), különben
      // a paging[t.key].skip a hiányzó kulcson eldobja az egész komponenst.
      paging: {
        accno: { skip: 0, take: 50 },
        dim13: { skip: 0, take: 50 },
        dim46: { skip: 0, take: 50 },
        dim79: { skip: 0, take: 50 },
        dim1012: { skip: 0, take: 50 },
        partner: { skip: 0, take: 50 },
        car: { skip: 0, take: 50 },
        szla: { skip: 0, take: 50 },
        project: { skip: 0, take: 50 },
        po: { skip: 0, take: 50 },
        recon: { skip: 0, take: 50 },
      },
      pageable: { buttonCount: 5, info: true, pageSizes: [25, 50, 100] },
      // A K2D w_popup_report_brief tab-sora (PONTOSAN 11 fül). Az engedélyezés módonként a `tabs` computed-ben.
      tabDefs: [
        {
          key: "accno",
          label: "Fksz",
          yearDependent: true,
          selectable: true,
          columns: [
            { field: "accno", title: "Fők. szám", width: "120px" },
            { field: "nationalLong", title: "Megnevezés" },
            { field: "note", title: "Megjegyzés", width: "200px" },
            { field: "thisLevelCharno", title: "Szint", width: "80px" },
          ],
        },
        {
          key: "dim13",
          label: "Dim 1-3",
          yearDependent: true,
          selectable: true,
          dimOrKey: "isDimOr",
          columns: [
            { field: "dimcode", title: "Dim. kód", width: "140px" },
            { field: "national", title: "Megnevezés" },
            { field: "note", title: "Megjegyzés", width: "200px" },
          ],
        },
        // Dim 4-12: csak is_dim_4_9='+' mellett aktívak; dim N = mmbokdimcode type N+1
        // (a kijelölés az ilboktmpextd-be megy, az SP as_dim4_6/7_9/10_12 kapcsolókkal EXISTS-el).
        {
          key: "dim46",
          label: "Dim 4-6",
          yearDependent: true,
          selectable: true,
          dimOrKey: "dimOr46",
          columns: [
            { field: "dimLabel", title: "Dim", width: "70px" },
            { field: "dimcode", title: "Dim. kód", width: "140px" },
            { field: "national", title: "Megnevezés" },
            { field: "note", title: "Megjegyzés", width: "200px" },
          ],
        },
        {
          key: "dim79",
          label: "Dim 7-9",
          yearDependent: true,
          selectable: true,
          dimOrKey: "dimOr79",
          columns: [
            { field: "dimLabel", title: "Dim", width: "70px" },
            { field: "dimcode", title: "Dim. kód", width: "140px" },
            { field: "national", title: "Megnevezés" },
            { field: "note", title: "Megjegyzés", width: "200px" },
          ],
        },
        {
          key: "dim1012",
          label: "Dim 10-12",
          yearDependent: true,
          selectable: true,
          dimOrKey: "dimOr1012",
          columns: [
            { field: "dimLabel", title: "Dim", width: "70px" },
            { field: "dimcode", title: "Dim. kód", width: "140px" },
            { field: "national", title: "Megnevezés" },
            { field: "note", title: "Megjegyzés", width: "200px" },
          ],
        },
        {
          key: "partner",
          label: "Partner",
          selectable: true,
          columns: [
            { field: "id", title: "ID", width: "90px" },
            { field: "name", title: "Partner" },
            { field: "taxAccount", title: "Adószám", width: "160px" },
          ],
        },
        {
          key: "car",
          label: "Gépjármű",
          selectable: true,
          columns: [
            { field: "reqNum", title: "Rendszám", width: "140px" },
            { field: "modell", title: "Modell" },
            { field: "owner", title: "Tulajdonos" },
          ],
        },
        { key: "szla", label: "Számla", columns: [] },
        {
          key: "project",
          label: "Project",
          selectable: true,
          columns: [
            { field: "code", title: "Kód", width: "160px" },
            { field: "name", title: "Megnevezés" },
          ],
        },
        {
          key: "po",
          label: "Megrendelés",
          selectable: true,
          columns: [
            { field: "poNumber", title: "Megrendelés szám" },
            { field: "workNumber", title: "Munkaszám" },
          ],
        },
        {
          key: "recon",
          label: "Pontozás",
          yearDependent: true,
          columns: [
            { field: "code", title: "Kód", width: "140px" },
            { field: "remark", title: "Megjegyzés" },
            { field: "accno", title: "Fők. szám", width: "120px" },
            { field: "statusName", title: "Állapot", width: "140px" },
            { field: "balance", title: "Egyenleg", width: "140px", format: "{0:n2}", className: "text-end" },
          ],
        },
      ],
    };
  },

  computed: {
    // A Számla-fül csak Karton módban aktív; a kivonatban tiltott (K2D w_popup_report_brief).
    isCarton(): boolean {
      return this.reportType === StatementReportType.Carton;
    },
    tabs(): TabView[] {
      return this.tabDefs.map((t) => {
        const count = t.selectable ? this.selCount(t.key) : 0;
        return {
          ...t,
          enabled: this.isTabEnabled(t.key),
          // K2D: a fül felirata mutatja a kiválasztott darabszámot, pl. "Fksz (3)".
          headerLabel: count > 0 ? `${t.label} (${count})` : t.label,
        };
      });
    },
  },

  async mounted() {
    // A configuration async töltődik app-startkor – mountkor frissítjük, ha a data() még a default-ot kapta.
    this.dim4to12Enabled = configuration.isDim49;
    await this.loadStatic();
    await this.loadYear();
  },

  methods: {
    // Fül-engedélyezés módonként (K2D w_popup_report_brief).
    isTabEnabled(key) {
      switch (key) {
        case "dim46":
        case "dim79":
        case "dim1012":
          return this.dim4to12Enabled; // gs_is_dim_4_9
        case "szla":
          return this.isCarton; // csak karton módban
        default:
          return true;
      }
    },

    // A választás-eredmény biztonságos betöltése (egy fül hibája nem dönti el a többit).
    // A sorok `selected` mezőt kapnak (pipa-oszlop); újratöltés = a fül kijelölése elvész.
    async safeLoad(key, fn) {
      try {
        this.rows[key] = (await fn()).map((r: any) => ({ ...r, selected: false }));
      } catch (e) {
        this.rows[key] = [];
        console.error(`StatementSelectorTabs: ${key} betöltése sikertelen`, e);
      }
      if (this.paging[key]) this.paging[key].skip = 0;
    },

    // Pipa-oszlop a kijelölhető fülek elé (K2D választó-lista; SelectorGrid minta).
    gridColumns(t) {
      if (!t.selectable) return t.columns;
      return [{ width: 46, cell: "selectorTemplate", filterable: false, sortable: false, headerClassName: "center_text" }, ...t.columns];
    },

    // Kliens-oldali kereső + "Csak a kijelöltek" nézet; a kijelölés a szűréstől függetlenül él.
    filteredRows(t) {
      let list = this.rows[t.key] || [];
      if (!t.selectable) return list;
      if (this.onlySelected[t.key]) list = list.filter((r: any) => r.selected);
      const q = (this.search[t.key] || "").toLowerCase().trim();
      if (!q) return list;
      const fields = t.columns.map((c: any) => c.field).filter(Boolean);
      return list.filter((r: any) => fields.some((f: string) => String(r[f] ?? "").toLowerCase().includes(q)));
    },

    // Az aktuális lap sorai (Kendo pageable kliens-oldali szeletelése).
    pagedRows(t) {
      const list = this.filteredRows(t);
      const p = this.paging[t.key];
      if (!p) return list;
      // Ha a szűkítés miatt a skip túlfutna a lista végén, visszaállunk az első lapra.
      if (p.skip >= list.length) p.skip = 0;
      return list.slice(p.skip, p.skip + p.take);
    },

    onPageChange(key, e) {
      this.paging[key].skip = e.page.skip;
      this.paging[key].take = e.page.take;
    },

    onSearch(key, value) {
      this.search[key] = value;
      this.paging[key].skip = 0;
    },

    setOnlySelected(key, value) {
      this.onlySelected[key] = value;
      this.paging[key].skip = 0;
    },

    // Dim-fül VAGY/ÉS kapcsolója (K2D rb_dim_or / cbx_dim_or*) – az érték a szűrőbe megy.
    setDimOr(key, value) {
      this.dimOr[key] = value;
      this.emitSelection();
    },

    selCount(key) {
      return (this.rows[key] || []).filter((r: any) => r.selected).length;
    },

    onSelect(key, item, value) {
      item.selected = value;
      this.emitSelection();
    },

    clearTab(key) {
      (this.rows[key] || []).forEach((r: any) => { r.selected = false; });
      // Ürítés után a "Csak a kijelöltek" nézet üres gridet mutatna → vissza a teljes listára.
      this.onlySelected[key] = false;
      this.emitSelection();
    },

    // A szülő (view) hívja reset-nél.
    clearAll() {
      Object.keys(this.rows).forEach((key) => (this.rows[key] || []).forEach((r: any) => { r.selected = false; }));
      Object.keys(this.onlySelected).forEach((key) => { this.onlySelected[key] = false; });
      // A VAGY/ÉS kapcsolók is a K2D-defaultra (VAGY) állnak vissza.
      Object.keys(this.dimOr).forEach((key) => { this.dimOr[key] = true; });
      this.emitSelection();
    },

    // A kijelölt elemek felküldése a szűrő-modellbe (a kulcsok a GeneralLedgerStatementFilter mezői).
    // A dim-fülek egy-egy gridek – a type bontja dim N listára (AccountingDimCode.type = N+1).
    emitSelection() {
      const sel = (key: string) => (this.rows[key] || []).filter((r: any) => r.selected);
      const byType = (list: any[], type: number) =>
        list.filter((r: any) => Number(r.type) === type).map((r: any) => r.dimcode);
      const dims = sel("dim13");
      const dims46 = sel("dim46");
      const dims79 = sel("dim79");
      const dims1012 = sel("dim1012");
      this.$emit("selection-change", {
        accnoList: sel("accno").map((r: any) => r.accno),
        dimcode1List: byType(dims, 2),
        dimcode2List: byType(dims, 3),
        dimcode3List: byType(dims, 4),
        dimcode4List: byType(dims46, 5),
        dimcode5List: byType(dims46, 6),
        dimcode6List: byType(dims46, 7),
        dimcode7List: byType(dims79, 8),
        dimcode8List: byType(dims79, 9),
        dimcode9List: byType(dims79, 10),
        dimcode10List: byType(dims1012, 11),
        dimcode11List: byType(dims1012, 12),
        dimcode12List: byType(dims1012, 13),
        partnerIds: sel("partner").map((r: any) => r.id),
        carIds: sel("car").map((r: any) => r.id),
        projectIds: sel("project").map((r: any) => r.id),
        poIds: sel("po").map((r: any) => r.id),
        // A dim-fülek VAGY/ÉS kapcsolói (K2D ps_dim_or / as_dim_or4_6/7_9/10_12).
        isDimOr: this.dimOr.dim13,
        dimOr46: this.dimOr.dim46,
        dimOr79: this.dimOr.dim79,
        dimOr1012: this.dimOr.dim1012,
      });
    },

    // Év-független fülek (egyszer töltődnek).
    async loadStatic() {
      if (this.staticLoaded) return;
      this.staticLoaded = true;
      await Promise.all([
        this.safeLoad("partner", () => api.GetStatementPartners()),
        this.safeLoad("car", () => api.GetStatementCars()),
        this.safeLoad("project", () => api.GetStatementProjects()),
        this.safeLoad("po", () => api.GetStatementPurchaseOrders()),
      ]);
    },

    // Év-függő fülek. A Fksz (invoice-mirror) és Dim (dimension) a NAPTÁRI évet várja; a Pontozás
    // (recon) a yearId-t (mmbokyear.szam = recon.year FK). A dimension-válasz EGYSZER jön le, és
    // type szerint oszlik a négy dim-fülre: dim13 = type 2-4, dim46 = 5-7, dim79 = 8-10, dim1012 = 11-13.
    async loadYear() {
      if (this.calendarYear) {
        await Promise.all([
          this.safeLoad("accno", () => api.GetInvoiceMirrorsByYear(this.calendarYear)),
          (async () => {
            let dims: any[] = [];
            try {
              dims = await api.GetStatementDimensions(this.calendarYear);
            } catch (e) {
              console.error("StatementSelectorTabs: dimenziók betöltése sikertelen", e);
            }
            const byType = (lo: number, hi: number) =>
              dims
                .filter((d: any) => Number(d.type) >= lo && Number(d.type) <= hi)
                .map((d: any) => ({ ...d, selected: false, dimLabel: DIM_ROMAN[Number(d.type)] || "" }));
            this.rows.dim13 = byType(2, 4);
            this.rows.dim46 = byType(5, 7);
            this.rows.dim79 = byType(8, 10);
            this.rows.dim1012 = byType(11, 13);
            ["dim13", "dim46", "dim79", "dim1012"].forEach((k) => { if (this.paging[k]) this.paging[k].skip = 0; });
          })(),
        ]);
      } else {
        this.rows.accno = [];
        this.rows.dim13 = [];
        this.rows.dim46 = [];
        this.rows.dim79 = [];
        this.rows.dim1012 = [];
      }
      if (this.yearId) {
        await this.safeLoad("recon", () => api.GetStatementRecons(this.yearId));
      } else {
        this.rows.recon = [];
      }
      // Év-váltásnál az újratöltött fülek kijelölése elveszett → a filter listáit is szinkronban tartjuk.
      this.emitSelection();
    },
  },

  watch: {
    yearId() {
      this.loadYear();
    },
  },
});
